import { render, staticRenderFns } from "./_content.vue?vue&type=template&id=1ecd31a2"
import script from "./_content.vue?vue&type=script&lang=js"
export * from "./_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports